import SearchIcon from '@material-ui/icons/Search';
import { Button, List, ListItem, ListItemText, Popover, Radio } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { Actions, State } from '../hooks/useChannelSetup';

const RenderPopover = ({
  state,
  actions,
  t,
  classes,
}: {
  state: State;
  actions: Actions;
  t: TFunction;
  classes: Record<string, string>;
}) => (
  <Popover
    open={Boolean(state.anchorEl)}
    anchorEl={state.anchorEl}
    onClose={actions.handleClosePopover}
    classes={{ paper: `${classes.popover} ${classes.magicLineLocations}` }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
  >
    <div className={classes.popOverSearch}>
      <div className={classes.popOverSearchInput}>
        <SearchIcon color="inherit" fontSize="inherit" />
        <input
          autoFocus
          className={classes.searchInput}
          placeholder={t('search.by.location.name')}
        />
      </div>
    </div>
    <List>
      {state.locations?.map((location, id: number) => (
        <ListItem
          key={id}
          onClick={() => actions.handleSelectItem(location.id, location.name)}
          className={classes.popOverListItem}
        >
          <ListItemText primary={location.name} />
          <Radio checked={state.selectedLocation === location.id} className={classes.radio} />
        </ListItem>
      ))}
    </List>
    <Button className={classes.closePopOver} onClick={actions.handleClosePopover}>
      {t('app.checkin.close')}
    </Button>
  </Popover>
);

export default RenderPopover;
